import React from "react";
import Loader from "../../../components/Loader";
import BoardList from "./BoardList";

function Navigation({ boards, isLoading, isError }) {
  return (
    <>
      {isLoading && (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      )}
      {!isLoading && isError && <BoardList boards={[]} />}
      {!isLoading && !isError && <BoardList boards={boards} />}
    </>
  );
}

export default Navigation;
